import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../App";

function AdminDashboard() {
	const [stats, setStats] = useState({
		employees: 0,
		departments: 0,
		onLeaveToday: 0,
	});
	const [todaySchedule, setTodaySchedule] = useState({});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		loadDashboard();
	}, []);

	const loadDashboard = async () => {
		try {
			const today = new Date();
			const todayDate = [
				today.getFullYear(),
				String(today.getMonth() + 1).padStart(2, "0"),
				String(today.getDate()).padStart(2, "0"),
			].join("-");
			const [employeesRes, departmentsRes, leaveRes] = await Promise.all([
				axios.get(`${API_URL}/employees`),
				axios.get(`${API_URL}/departments`),
				axios.get(
					`${API_URL}/requests?status=approved&startDate=${todayDate}&endDate=${todayDate}`,
				),
			]);

			setStats({
				employees: employeesRes.data.length,
				departments: departmentsRes.data.length,
				onLeaveToday: new Set(
					leaveRes.data.map((leave) => leave.employee_id),
				).size,
			});

			// Get today's schedule
			const scheduleRes = await axios.get(
				`${API_URL}/schedules/by-date/${todayDate}`,
			);
			setTodaySchedule(scheduleRes.data);
		} catch (error) {
			console.error("Error loading dashboard:", error);
		} finally {
			setLoading(false);
		}
	};

	if (loading) {
		return (
			<div className='loading-container'>
				<div className='spinner'></div>
			</div>
		);
	}

	const today = new Date();
	const formattedDate = today.toLocaleDateString("en-US", {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric",
	});

	return (
		<div>
			<div className='page-header'>
				<div>
					<h1 className='page-title'>Dashboard</h1>
					<p className='text-muted text-sm'>{formattedDate}</p>
				</div>
			</div>

			<div className='stats-grid'>
				<div className='stat-card primary'>
					<div className='stat-label'>Active Employees</div>
					<div className='stat-value'>{stats.employees}</div>
				</div>
				<div className='stat-card'>
					<div className='stat-label'>Departments</div>
					<div className='stat-value'>{stats.departments}</div>
				</div>
				<div className='stat-card'>
					<div className='stat-label'>On Leave Today</div>
					<div className='stat-value'>{stats.onLeaveToday}</div>
				</div>
				<div className='stat-card'>
					<div className='stat-label'>Working Today</div>
					<div className='stat-value'>
						{Object.values(todaySchedule).reduce(
							(sum, dept) => sum + dept.length,
							0,
						)}
					</div>
				</div>
			</div>

			<div className='card'>
				<div className='card-header'>
					<h3>Today's Schedule</h3>
				</div>
				{Object.keys(todaySchedule).length === 0 ? (
					<p
						className='text-muted text-center'
						style={{ padding: "2rem" }}
					>
						No assignments scheduled for today.
					</p>
				) : (
					<div className='grid-2'>
						{Object.entries(todaySchedule).map(
							([deptName, employees]) => (
								<div
									key={deptName}
									style={{
										padding: "1rem",
										background: "var(--gray-50)",
										borderRadius: "var(--radius-md)",
									}}
								>
									<h4
										style={{
											color: "var(--primary-700)",
											marginBottom: "0.5rem",
											display: "flex",
											alignItems: "center",
											gap: "0.5rem",
										}}
									>
										<span
											style={{
												width: "8px",
												height: "8px",
												borderRadius: "50%",
												background:
													"var(--primary-500)",
											}}
										></span>
										{deptName}
									</h4>
									<ul
										style={{
											listStyle: "none",
											padding: 0,
										}}
									>
										{employees.map((emp) => (
											<li
												key={emp.employeeId}
												style={{
													padding: "0.25rem 0",
													fontSize: "0.875rem",
													color: "var(--gray-700)",
												}}
											>
												{emp.firstName}
												{emp.employeeNumber && (
													<span className='text-muted'>
														{" "}
														(#{emp.employeeNumber})
													</span>
												)}
											</li>
										))}
									</ul>
								</div>
							),
						)}
					</div>
				)}
			</div>

		</div>
	);
}

export default AdminDashboard;
